import { axiosHelper } from 'Services/AxiosHelper';
import { OnSaveCustomerCardModel } from 'Models';
import { onSaveCustomerCardBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnSaveCustomerCard';

const onSaveCustomerCard = async (params: onSaveCustomerCardBodyData): Promise<OnSaveCustomerCardModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onSaveCustomerCard;
